import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TransactionChats, formatBalance, formatDate } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useCreateProblemTransactionChatMutation,
  useLazyGetProblemTransactionSenderClientsOfficiasQuery,
} from '../store/services/customers';

const OutgoingTransactionChats = (): React.JSX.Element => {
  const {
    customersProblemTransactions: {
      outgoing: { chats, transaction, senderCompanyOfficials },
    },
    customersDictionaries: {
      currentEmployee,
      currenciesList,
      activePermissions,
    },
  } = useAppSelector((state) => state);

  const [createTransactionChat, { isLoading: chatCreateInProgress }] =
    useCreateProblemTransactionChatMutation();

  const [getSenderAccounts] =
    useLazyGetProblemTransactionSenderClientsOfficiasQuery();

  const { transactionId } = useParams();

  const onCreateTransactionChat = (userIds?: string[]) => {
    const title = `RFI: Outgoing transaction ${formatBalance(
      transaction?.sum || 0,
      currenciesList?.find((item) => item.id === transaction?.currencyId),
    )} ${transaction?.currency?.name} ${
      transaction?.transferDate ? formatDate(transaction?.transferDate) : ''
    }`;

    if (!userIds?.length) {
      createTransactionChat({
        id: transactionId as string,
        body: {
          title,
          employeeId: currentEmployee?.id as string,
          organizationId: transaction?.senderAccount?.organizationId,
        },
      });
    } else {
      Promise.all(
        userIds.map((item) =>
          createTransactionChat({
            id: transactionId as string,
            body: {
              title,
              employeeId: currentEmployee?.id as string,
              organizationId: transaction?.senderAccount?.organizationId,
              userId: item,
            },
          }),
        ),
      );
    }
  };

  useEffect(() => {
    if (
      transaction &&
      transaction.senderAccount &&
      transaction.senderAccount?.organization?.type === 'CORPORATE' &&
      !senderCompanyOfficials
    ) {
      getSenderAccounts(transaction.senderAccount.organizationId);
    }
  }, [transaction, senderCompanyOfficials]);

  return (
    <TransactionChats
      chats={chats}
      companyOfficials={senderCompanyOfficials}
      individualCustomer={transaction?.senderAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
    />
  );
};

export default OutgoingTransactionChats;
